import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown'
import { useRef, useState } from 'react'
import styled from 'styled-components'

import useOnClickOutside from '../../../hooks/useOnClickOutside'
import theme, { rem } from '../../../utils/theme'
import Dropdown from '../../Dropdown'
import StackedNav from '../../StackedNav'

const StyledOrgUserDropdown = styled.nav`
  display: flex;
`

const StyledToggle = styled.button`
  height: ${rem(theme.regoForm.pageHeaderHeightMobile)};
  display: flex;
  align-items: center;
  appearance: none;
  cursor: pointer;
  user-select: none;
  border: 0;
  background: none;
  padding: 0 ${rem(12)};
  transition: ${theme.transitions.short};
  position: relative;

  ${theme.breakpoints.up('sm')} {
    height: ${rem(theme.regoForm.pageHeaderHeightDesktop)};
  }

  &:focus {
    outline: 0;
    box-shadow: ${theme.focusRings.shadow({ inset: true })};
  }
`

const StyledInner = styled.div`
  display: flex;
  height: 100%;

  ${theme.breakpoints.up('sm')} {
    position: relative;
  }
`

const StyledInfo = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  flex: 1;
  text-align: right;

  ${theme.breakpoints.down('sm')} {
    display: none;
  }
`

const StyledOrgName = styled.div`
  font-size: ${theme.typography.fontSizeTinyish};
  color: ${theme.regoForm.pageHeaderColorLight};
  margin: 0 0 ${rem(2)};
`

const StyledUserName = styled.div`
  font-size: ${theme.typography.fontSizeSm};
  font-weight: ${theme.typography.fontWeightBold};
  color: ${theme.regoForm.pageHeaderColor};

  > svg {
    display: inline-block;
    vertical-align: middle;
    margin: ${rem(-1)} ${rem(-4)} 0 ${rem(4)};
  }
`

const StyledOrgLogo = styled.div`
  display: flex;
  align-items: center;
  height: 100%;

  ${theme.breakpoints.up('sm')} {
    margin-left: ${rem(30)};
  }

  > img {
    display: block;
    max-height: ${rem(44)};
  }
`

const StyledDropdownWrap = styled.div`
  position: absolute;
  top: 100%;
  right: ${rem(10)};
  width: ${rem(220)};
  pointer-events: none;

  ${theme.breakpoints.up('sm')} {
    right: ${rem(-30)};
  }
`

const StyledDropdownInfo = styled.div`
  padding: ${rem(6)} ${rem(10)} ${rem(2)};
  margin: 0 0 ${rem(12)};
  text-align: left;

  ${theme.breakpoints.up('sm')} {
    display: none;
  }
`
/* eslint-disable-next-line no-unused-vars */
// biome-ignore lint/correctness/noUnusedVariables: TODO
const StyledAppVersion = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-start;
  color: ${theme.colors.darkGrey};
  font-size: ${theme.typography.fontSizeTiny};
  padding: ${rem(16)} ${rem(10)} 0;
`

const StyledDropdownNav = styled.div``

// biome-ignore lint/correctness/noUnusedFunctionParameters: TODO
function OrgUserDropdown({ orgName, orgLogo, userName, logOutRequest, landingPageLink, portalLink, appVersion }) {
  const dropdownRef = useRef()
  const toggleRef = useRef()
  const [userNavOpen, setUserNavOpen] = useState(false)

  useOnClickOutside(dropdownRef, () => setUserNavOpen(false))

  const handleToggleDropdown = () => {
    setUserNavOpen(!userNavOpen)
  }

  const navItems = [
    {
      show: !!landingPageLink,
      label: 'Event Landing Page',
      href: landingPageLink,
      isExternal: true,
    },
    {
      show: !!portalLink,
      label: 'Team Manager Portal',
      href: portalLink,
      isExternal: true,
    },
    {
      show: true,
      label: 'Log Out',
      href: '#',
      onClick: e => logOutRequest(e),
      tabIndex: userNavOpen ? 0 : -1,
      isRequired: { label: 'Log Out' },
    },
  ]

  return (
    <StyledOrgUserDropdown ref={dropdownRef} aria-label="Organisation and User Information">
      <StyledToggle
        onClick={handleToggleDropdown}
        ref={toggleRef}
        aria-label="Toggle navigation"
        aria-expanded={userNavOpen}
        data-testid="formHeaderProfileSection"
      >
        <StyledInner>
          <StyledInfo>
            <StyledOrgName>{orgName}</StyledOrgName>
            <StyledUserName>
              {userName}
              <ArrowDropDownIcon style={{ fontSize: 16 }} />
            </StyledUserName>
          </StyledInfo>
          <StyledDropdownWrap>
            <Dropdown isOpen={userNavOpen}>
              <StyledDropdownInfo>
                <StyledOrgName>{orgName}</StyledOrgName>
                <StyledUserName>{userName}</StyledUserName>
              </StyledDropdownInfo>
              <StyledDropdownNav>
                <StackedNav items={navItems} isCompact />
                {/* <StyledAppVersion>{appVersion}</StyledAppVersion> */}
              </StyledDropdownNav>
            </Dropdown>
          </StyledDropdownWrap>
        </StyledInner>
        {orgLogo && (
          <StyledOrgLogo>
            <img src={orgLogo} alt={orgName} />
          </StyledOrgLogo>
        )}
      </StyledToggle>
    </StyledOrgUserDropdown>
  )
}

export default OrgUserDropdown
